var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFbkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 15.833h4.166V4.167H4.167v11.666H10v-4.166H8.333V10H10V8.622c0-1.114.117-1.519.333-1.926.214-.403.544-.733.947-.946.318-.17.714-.273 1.406-.317.274-.018.629.004 1.065.066v1.583h-.418c-.764 0-1.08.036-1.268.137a.606.606 0 00-.262.262c-.1.188-.136.375-.136 1.14V10h2.083l-.417 1.667h-1.666v4.166zM3.333 2.5h13.334c.46 0 .833.373.833.833v13.334c0 .46-.373.833-.833.833H3.333a.833.833 0 01-.833-.833V3.333c0-.46.373-.833.833-.833z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgIcoFbkWhite;